import Vue from 'vue'
import moment from 'moment'
// Vue.prototype.$moment = moment
Vue.filter('datefmt', function (time, fmtstring) {
  //当time为时间戳时，需转为Number类型
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(Number(time + '000')).format(fmtstring);
});

const filters = {
  converCourseTime: function (time) {
    let result = ""
    let hourTime = 0;
    let minuteTime = 0;
    minuteTime = parseInt(time / 60);
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60);
      minuteTime = parseInt(minuteTime % 60);
    }
    if (hourTime !== 0) {
      result = hourTime + "时" + minuteTime + "分"

    } else {
      result = minuteTime + "分" + time%60 + '秒'
    }
    return result
  }
}

export default (vm) => {
  Object.keys(filters).forEach(key => {
    vm.filter(key, filters[key])
  })
}

